import { Flex, Text } from "@mantine/core";
import { type IPositionItem } from "src/pages/Settings/YachtSetup/DynamicPositioningSetup/DynamicPositioningSetup.types";

import { StyledYachtSetUpItem } from "../YachtSetUp.styled";

interface Props {
  list: IPositionItem[];
}

const DisabledPositioningList = ({ list }: Props) => {
  return (
    <Flex w="100%" direction="column" align="center" mt="md">
      {list.map((item, index) => (
        <StyledYachtSetUpItem key={index}>
          <Text size="sm">Short Code:</Text>
          <Text style={{ flex: 1 }}>{item.code}</Text>
          <Text size="sm">Description:</Text>
          <Text style={{ flex: 1 }}>{item.desc}</Text>
        </StyledYachtSetUpItem>
      ))}
    </Flex>
  );
};

export default DisabledPositioningList;
